import React from 'react';
import {
  Box,
  Button,
  FormControlLabel,
  ButtonProps as MuiButtonProps,
  Switch,
  Typography,
  TypographyTypeMap,
} from '@mui/material';

interface ButtonProps extends MuiButtonProps {
  textVariant?: TypographyTypeMap['props']['variant'];
}

const ReviewFieldsButton: React.FC<ButtonProps> = ({
  textVariant = 'body2',
  ...props
}) => {
  return (
    <Button sx={{ textTransform: 'none' }} {...props}>
      <Typography variant={textVariant} fontWeight="fontWeightMedium">
        Review Fields
      </Typography>
    </Button>
  );
};

const SwitchableItem: React.FC<any> = ({
  checked,
  disabled = false,
  label,
  onChange,
}) => {
  return (
    <FormControlLabel
      control={
        <Switch checked={!!checked} onChange={onChange} disabled={disabled} />
      }
      label={label}
    />
  );
};

const SidePanel: React.FC<any> = ({ children }) => {
  return <Box sx={{ p: 2, pb: 9 }}>{children}</Box>;
};

const SaveButton: React.FC<any> = ({
  disabled = true,
  onClick: handleClick,
  marginTop = 2,
}) => {
  return (
    <Box>
      <Button
        color="primary"
        data-testid="save-changes-button"
        disabled={disabled}
        fullWidth
        onClick={(e) => {
          handleClick(e);
        }}
        sx={{
          mt: marginTop,
        }}
        variant="contained"
      >
        Save Changes
      </Button>
    </Box>
  );
};

export { ReviewFieldsButton, SaveButton, SwitchableItem, SidePanel };
